// "use client";
// import { useState } from "react";

// const faqs = [
//   {
//     question: "What is Kubermax?",
//     answer:
//       "Kubermax is a short-term loan service designed specifically for salaried individuals who need instant financial assistance with minimal documentation.",
//   },
//   {
//     question: "How quickly can I get a loan?",
//     answer:
//       "Loan approvals are processed within minutes. Once approved, the amount is disbursed directly to your bank account, often within the same day.",
//   },
//   {
//     question: "What documents are required for applying?",
//     answer:
//       "We require basic documents like a valid ID proof, your latest salary slip, and a bank statement to verify your salary account.",
//   },
//   {
//     question: "Who is eligible to apply for a loan?",
//     answer:
//       "Any salaried individual between the age of 21–58 with a stable monthly income and an active salary account is eligible to apply.",
//   },
//   {
//     question: "Is the loan process completely online?",
//     answer:
//       "Yes, the entire process from application to disbursal is 100% digital, ensuring convenience and speed without any physical paperwork.",
//   },
//   {
//     question: "What is the interest rate on the loan?",
//     answer:
//       "Our interest rate ranges from 0.25% to 1% per day depending on your profile, tenure, and loan amount.",
//   },
//   {
//     question: "What is the maximum loan amount I can borrow?",
//     answer:
//       "You can borrow any amount between ₹5,000 to ₹100,000, subject to your eligibility and income profile.",
//   },
//   {
//     question: "Is my personal data safe with Kubermax?",
//     answer:
//       "Absolutely. We follow industry-standard encryption protocols and never share your information with third parties without consent.",
//   },
// ];

// const FAQSection = () => {
//   const [openIndex, setOpenIndex] = useState(null);

//   const toggle = (index) => {
//     setOpenIndex(openIndex === index ? null : index);
//   };

//   return (
//     <section
//       style={{
//         background: "linear-gradient(to right,#E3E8F0, #D6E4FF)",
//         padding: "4rem 0",
//         position: "relative",
//         overflow: "hidden",
//       }}
//     >
//       {/* Decorative circles */}
//       <div
//         style={{
//           position: "absolute",
//           top: "-100px",
//           right: "-100px",
//           width: "300px",
//           height: "300px",
//           borderRadius: "50%",
//           background: "rgba(255, 255, 255, 0.08)",
//           animation: "float 6s ease-in-out infinite",
//         }}
//       />
//       <div
//         style={{
//           position: "absolute",
//           bottom: "-150px",
//           left: "-150px",
//           width: "400px",
//           height: "400px",
//           borderRadius: "50%",
//           background: "rgba(255, 255, 255, 0.05)",
//           animation: "float 8s ease-in-out infinite reverse",
//         }}
//       />

//       <div
//         className="max-w-[900px] m-auto px-4"
//         style={{ position: "relative", zIndex: 1 }}
//       >
//         <div
//           style={{
//             textAlign: "center",
//             marginBottom: "3rem",
//             animation: "fadeInDown 0.8s ease-out",
//           }}
//         >
//           <h2 className="text-3xl sm:text-4xl font-bold mt-2">
//             <span className="text-[#1D3557]">Frequently</span>{" "}
//             <span className="text-[#2563EB]">Asked Questions</span>
//           </h2>

//         </div>

//         <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
//           {faqs.map((faq, index) => (
//             <div
//               key={index}
//               style={{
//                 background: openIndex === index ? "#fff" : "#1D3557",
//                 borderRadius: 16,
//                 boxShadow:
//                   openIndex === index
//                     ? "0 8px 32px rgba(0,0,0,0.15)"
//                     : "0 4px 12px rgba(0,0,0,0.1)",
//                 transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//                 overflow: "hidden",
//                 transform:
//                   openIndex === index ? "translateY(-4px)" : "translateY(0)",
//                 animation: `fadeInUp 0.5s ease-out ${index * 0.1}s backwards`,
//                 border:
//                   openIndex === index
//                     ? "2px solid #FFD700"
//                     : "2px solid transparent",
//               }}
//               onMouseEnter={(e) => {
//                 if (openIndex !== index) {
//                   e.currentTarget.style.transform = "translateY(-2px)";
//                   e.currentTarget.style.boxShadow =
//                     "0 6px 20px rgba(0,0,0,0.12)";
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 if (openIndex !== index) {
//                   e.currentTarget.style.transform = "translateY(0)";
//                   e.currentTarget.style.boxShadow =
//                     "0 4px 12px rgba(0,0,0,0.1)";
//                 }
//               }}
//             >
//               <button
//                 style={{
//                   width: "100%",
//                   textAlign: "left",
//                   padding: "1.4rem 2rem",
//                   fontWeight: 600,
//                   fontSize: "1.12rem",
//                   color: openIndex === index ? "#1D3557" : "#fff",
//                   background: "none",
//                   border: "none",
//                   outline: "none",
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   cursor: "pointer",
//                   transition: "all 0.3s ease",
//                 }}
//                 onClick={() => toggle(index)}
//               >
//                 <span
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "12px",
//                   }}
//                 >
//                   <span
//                     style={{
//                       width: "6px",
//                       height: "6px",
//                       borderRadius: "50%",
//                       background: openIndex === index ? "#4FA0FF" : "#FFD700",
//                       transition: "all 0.3s ease",
//                       transform:
//                         openIndex === index ? "scale(1.3)" : "scale(1)",
//                     }}
//                   />
//                   {faq.question}
//                 </span>
//                 <span
//                   style={{
//                     marginLeft: 12,
//                     fontSize: 28,
//                     fontWeight: 300,
//                     color: openIndex === index ? "#4FA0FF" : "#FFD700",
//                     transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//                     transform:
//                       openIndex === index ? "rotate(180deg)" : "rotate(0deg)",
//                     display: "inline-block",
//                   }}
//                 >
//                   {openIndex === index ? "−" : "+"}
//                 </span>
//               </button>
//               <div
//                 style={{
//                   maxHeight: openIndex === index ? "500px" : "0",
//                   opacity: openIndex === index ? 1 : 0,
//                   padding:
//                     openIndex === index ? "0 2rem 1.4rem 2rem" : "0 2rem",
//                   color: "#1D3557",
//                   fontSize: "1.05rem",
//                   lineHeight: "1.7",
//                   transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
//                   overflow: "hidden",
//                 }}
//               >
//                 <div
//                   style={{
//                     paddingLeft: "18px",
//                     borderLeft: "3px solid #4FA0FF",
//                     animation:
//                       openIndex === index
//                         ? "slideInLeft 0.5s ease-out"
//                         : "none",
//                   }}
//                 >
//                   {faq.answer}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       <style>{`
//         @keyframes float {
//           0%, 100% {
//             transform: translateY(0) rotate(0deg);
//           }
//           50% {
//             transform: translateY(-20px) rotate(5deg);
//           }
//         }

//         @keyframes fadeInDown {
//           from {
//             opacity: 0;
//             transform: translateY(-30px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes fadeInUp {
//           from {
//             opacity: 0;
//             transform: translateY(30px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes expandWidth {
//           from {
//             width: 0;
//           }
//           to {
//             width: 80px;
//           }
//         }

//         @keyframes slideInLeft {
//           from {
//             opacity: 0;
//             transform: translateX(-20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateX(0);
//           }
//         }

//         @media (max-width: 768px) {
//           h2 {
//             font-size: 1.8rem !important;
//           }
//         }
//       `}</style>
//     </section>
//   );
// };
"use client";
import { useState } from "react";

const faqs = [
  {
    question: "What is Kubermax?",
    answer:
      "Kubermax is a short-term financial support service designed for salaried individuals who need instant financial assistance with minimal documentation.",
  },
  {
    question: "How quickly can I get funds?",
    answer:
      "Support approvals are processed within minutes and the amount is often transferred the same day.",
  },
  {
    question: "What documents are required?",
    answer:
      "A valid ID proof, latest salary slip, and bank statement of your salary account.",
  },
  {
    question: "Who is eligible?",
    answer:
      "Salaried individuals aged 21–58 with stable income and an active salary account.",
  },
  {
    question: "Is the process fully online?",
    answer:
      "Yes, the entire process is completely digital — no physical paperwork needed.",
  },
  // {
  //   question: "What is the service rate?",
  //   answer:
  //     "Service rates range between 0.25% to 1% per day depending on your profile.",
  // },
  {
    question: "Maximum support amount?",
    answer: "You can access between ₹5,000 and ₹100,000 in financial support.",
  },
  {
    question: "Is my data safe?",
    answer:
      "Yes, all your data is protected with industry-grade encryption and never shared.",
  },
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="relative py-24 bg-[#050A18] overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A1020] via-[#0C152B] to-[#050A18] opacity-90"></div>

      {/* Neon Glow Blobs */}
      <div className="absolute top-[-80px] left-[-80px] w-[350px] h-[350px] bg-[#4FA0FF]/20 blur-[160px] rounded-full"></div>
      <div className="absolute bottom-[-80px] right-[-80px] w-[350px] h-[350px] bg-[#0066FF]/20 blur-[170px] rounded-full"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10">
        {/* Heading */}
        <h2 className="text-4xl font-extrabold text-center text-white mb-14">
          Frequently Asked <span className="text-[#4FA0FF]">Questions</span>
        </h2>

        {/* FAQ List */}
        <div className="flex flex-col gap-6">
          {faqs.map((faq, index) => (
            <div key={index} className="transition-all duration-300">
              {/* QUESTION - Glass Card */}
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex justify-between items-center text-left py-4 px-5 
bg-white/5 backdrop-blur-lg rounded-xl
border border-[#4FA0FF]/40
shadow-[0_0_15px_#4FA0FF20] hover:shadow-[0_0_25px_#4FA0FF0]
transition-all"
              >
                <span className="text-lg text-white font-semibold flex items-center gap-3">
                  <span className="w-2 h-2 rounded-full bg-[#4FA0FF] "></span>
                  {faq.question}
                </span>

                <span
                  className={`text-3xl text-[#4FA0FF] transform transition-transform duration-300 ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                >
                  +
                </span>
              </button>

              {/* ANSWER BOX */}
              <div
                className={`transition-all overflow-hidden ${
                  openIndex === index
                    ? "max-h-96 opacity-100 mt-3"
                    : "max-h-0 opacity-0"
                }`}
              >
                <div className="bg-white/5 backdrop-blur-xl rounded-xl p-5 shadow-[0_0_20px_#4FA0FF15]">
                  <p className="text-white/85 text-base leading-relaxed border-l-2 border-[#4FA0FF]/40 pl-4">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;